"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.productCompare.name': 'Confronta Prodotti',
    'tools.productCompare.description': 'Confronta prodotti da specifici domini e-commerce e siti web',
};
